import React, { useMemo } from 'react';
import { Button } from 'react-bootstrap';

import dateFormat from 'dateformat';

import { BootstrapVerticalColumnTable } from '@components/Table/Table';

const renderPDFCell = ({ value }) => (
  <Button
    className="btn-sm"
    variant="didxl"
    as="a"
    href={value}
    target="_blank"
    size="sm"
  >
    PDF
  </Button>
);

export const InvoiceDetailsTable = ({ data }) => {
  const verticalColumns = useMemo(
    () => [
      {
        id: 'invoiceID',
        Header: '',
        accessor: 'uuid',
      },
      {
        Header: 'Invoice ID',
        accessor: 'reference_number',
        className: 'col-md-3',
      },
      {
        Header: 'Invoice Date',
        accessor: 'date_created',
        className: 'col-md-1',
        Cell: ({ value }) => {
          const date = new Date(value);
          return dateFormat(date, 'defaultDate');
        },
      },
      {
        Header: 'Due Date',
        accessor: 'date_due',
        className: 'col-md-1',
        Cell: ({ value }) => {
          const date = new Date(value);
          return dateFormat(date, 'defaultDate');
        },
      },
      {
        Header: 'Total',
        accessor: 'total',
        className: 'col-md-1',
      },
      {
        Header: 'Traffic',
        accessor: 'traffic',
        className: 'col-md-1',
      },
      {
        Header: 'Numbers',
        accessor: 'numbers',
        className: 'col-md-1',
      },
      {
        id: 'pdf',
        Header: 'PDF',
        className: 'col-md-2',
        accessor: 'pdf_location',
        Cell: renderPDFCell,
      },
    ],
    []
  );
  return (
    <BootstrapVerticalColumnTable
      columns={verticalColumns}
      data={data}
      tableProps={() => ({
        responsive: true,
        borderless: true,
        className: 'normalFontSize',
      })}
      hiddenColumns="invoiceID"
    />
  );
};
